import { PollCard } from '@/components/poll/PollCard';
import type { SocialPost } from '../../types';

interface PollPostContentProps {
  post: SocialPost;
  onInteracted?: () => void;
}

export function PollPostContent({ post, onInteracted }: PollPostContentProps) {
  if (post.type !== 'POLL') return null;

  const communityId = post.communityId || '';

  let pollOptions = post.pollOptions;
  if (typeof pollOptions === 'string') {
    try {
      pollOptions = JSON.parse(pollOptions);
    } catch (e) {
      console.error('Failed to parse pollOptions:', e);
      pollOptions = [];
    }
  }
  if (!Array.isArray(pollOptions)) {
    pollOptions = [];
  }

  pollOptions = pollOptions
    .filter((opt) => opt)
    .map((opt) => ({
      id: opt.id || (opt as { optionId?: string }).optionId || '',
      text: opt.text || (opt as { optionText?: string }).optionText || '',
      order: opt.order ?? (opt as { optionOrder?: number }).optionOrder ?? 0,
      voteCount: Number(opt.voteCount) || 0,
      percentage: Number(opt.percentage) || 0,
    }));

  return (
    <div className="w-full">
      <PollCard
        communityId={communityId}
        poll={{
          id: post.pollId,
          question: post.pollQuestion,
          isAnonymous: post.pollIsAnonymous,
          allowMultiple: post.pollAllowMultiple,
          expiresAt: post.pollExpiresAt,
          createdAt: post.createdAt,
          author: {
            id: post.authorId,
            name: `${post.authorFirstName || ''} ${post.authorLastName || ''}`.trim(),
            image: post.authorImage,
          },
        }}
        options={pollOptions}
        userVote={post.userPollVote || null}
        userVotes={post.userPollVotes || []}
        totalVotes={post.pollTotalVotes || 0}
        voters={post.pollVoters || []}
        onInteracted={onInteracted}
      />
    </div>
  );
}
